import SEOHead from '@/components/base/SEOHead';
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="年轻的妈妈 - 新手育儿全攻略 | 新生儿护理、产后恢复、母乳喂养、宝宝早教"
        description="专为年轻的妈妈打造的育儿指南，涵盖新生儿护理、产后恢复、母乳喂养、宝宝早教及妈妈自我成长，帮助每一位年轻的妈妈从容应对育儿挑战，找到属于自己的育儿节奏与生活平衡。"
        keywords="年轻的妈妈,年轻妈妈育儿技巧,新手妈妈产后恢复,年轻妈妈母乳喂养,新生儿护理指南,年轻妈妈自我成长,宝宝早教方法"
        canonicalUrl="https://young-mama.com"
      />
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="年轻的妈妈 - 新手育儿全攻略"
        description="专为年轻的妈妈打造的育儿指南，涵盖新生儿护理、产后恢复、母乳喂养、宝宝早教及妈妈自我成长。"
        url="https://young-mama.com"
      />

      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
    </>
  );
}